;(function(){
    var root
    var isNode
    var guidNames = {}
    
    if (typeof module !== 'undefined' && module.exports) {
        isNode = true
        root = global
    } else {
        isNode = false
        root = window
    }

    function isMessageVisible(msg) {
        var quantities = msg.quantities || {}
        var attr = msg.ATTRIBUTES || {}
        if (quantities.hideWhenRedeemed &&  attr.status == "redeemed") {
            return false
        }
        
        if (quantities.hideWhenRead &&  attr.status == "read") {
            return false
        }
        
        return true
    }
    
    isMessageVisible._depends = {
        symbol : "3r/chi/isMessageVisible"
    }
    
    function lookupAndLoad(messageStaticLookup, loadPackage, msg) {
    
        if (messageStaticLookup) {
            var staticLookup = messageStaticLookup(msg)
            
            if (staticLookup) {
                return staticLookup.then(function () {
                    return loadPackage(msg)
                })
            } else {
                return loadPackage(msg)
            }
        } else {
            return loadPackage(msg)
        }
    }
    
    lookupAndLoad._depends = {
        symbol : "3r/chi/lookupAndLoad",
        modules : [
            {
                symbol : "3r/message-api/content/messageStaticLookup",
                nullIfMissing : true
            },
            "3r/chi/loadPackage"
        ]
    }
    
    function loadPackage(getPackageName, chiHelpers, createMainScript, message) {
        return getPackageName(message)
            .then(function (packageName) {
                var packageVariable  = chiHelpers.camelCase(packageName);
    
                if (window[packageVariable]) {
                    return packageVariable;
                } else {
                    return createMainScript(message)
                        .then(function (packageData) {
                            return packageVariable;
                        })
                }
            })
    }
    
    loadPackage._depends = {
        symbol : "3r/chi/loadPackage",
        modules : [
            "3r/chi/getPackageName",
            "3r/chi/helpers",
            "3r/chi/createMainScript"
        ]
    }
    
    function createMainScript(Promise, Device, getPackageUrl, getPackageGuid, message) {
        var packageUrl = getPackageUrl(message);
        var packageGuid = getPackageGuid(packageUrl);
        var schemeIdStr = (message.schemeId || Device.schemeId).toString();
    
        return new Promise(function (accept, reject) {
            var jsMainAddress = Device.getApiAddress({
                port: 3001,
                path: "/external-package/" + schemeIdStr + "/" + packageGuid + "/main.js"
            })
    
            var script = document.createElement('script');
            script.onload = function () {
                accept(jsMainAddress)
            }
    
            script.onerror = function(e) {
                return reject(e)
            }
    
            script.src = jsMainAddress;
    
            !(document.getElementsByTagName('body')[0] || document.getElementsByTagName('head')[0]).appendChild(script)
        })
    }
    
    createMainScript._depends = {
        symbol : "3r/chi/createMainScript",
        modules : [
            "Promise",
            "3r/Device",
            "3r/chi/getPackageUrl",
            "3r/chi/getPackageGuid"
        ]
    }
   
    function loadScript(Promise, Device, getPackageGuid, schemeId, packageUrl) {
        var packageGuid = getPackageGuid(packageUrl);
        var loadScriptJsAddress = this.device.getApiAddress({
            port : 3001,
            path : "/external-package/" + schemeId + "/" + packageGuid + "/main.js"
        });
        
        return new Promise(function (accept, reject){
            var script = document.createElement('script')
            
    		script.onload = function() {
    			accept(loadScriptJsAddress)
    		};
    		script.onerror = function(e) {
    			reject(e)
    		};
    		
    		script.src = loadScriptJsAddress;
    		
    		!(document.getElementsByTagName('body')[0] || document.getElementsByTagName("head")[0]).appendChild(script);
        })
    }
    
    loadScript._depends = {
        symbol : "3r/chi/loadScript",
        modules : [
            "Promise",
            "3r/Device",
            "3r/chi/getPackageGuid"
        ]
    }
    
    function resolveThreeRadicalConfig(helpers, resolveThreeRadicalSubPackage, message, options) {
    	let threeRadical = helpers.getThreeRadical(message)
    	if (threeRadical) {
    		return helpers.resolveThreeRadical(
    			threeRadical,
    			'threeRadical',
    			true,
    			function(subPackage) {
    				return resolveThreeRadicalSubPackage ? resolveThreeRadicalSubPackage(subPackage, options) : undefined
    			},
    			{ "isRemapFilePaths": (options || {}).remapDomain || true }
    		)
    	} else {
    		return null
    	}
    }
    
    resolveThreeRadicalConfig._depends = {
        symbol : "3r/chi/resolveThreeRadicalConfig",
        modules : [
            "3r/chi/helpers",
            {
                symbol : "3r/chi/resolveThreeRadicalSubPackage",
                nullIfMissing : true
            }
        ]
    }
    
    function resolveThreeRadicalSubPackage(device, helpers, loadScript, getPackageGuid, isMessageVisible, lookupAndLoad, resolveThreeRadicalConfig, subPackage, options) {
    	if ((subPackage.metadata || {}).type == "tactic") {
    		let tactic = subPackage.tactic
    		let fn = function(modules, config, el, msg) {
    			if (!msg) {
    				msg = device.allMessages
    					.filter(isMessageVisible)
    					.filter(m => m.systemId == tactic.id)[0]
    				
    				/* Sub package has been called with a specific message .:. resolve the correct messsage.
    				 * The message reference in gameDevice needs to be updated, don't assume game device is standard
    				 * container packages may override functions or use a different implementation entirely
    				 */
    				
    				let devicePrototype = Object.getPrototypeOf(modules.device)
    				let newGameDevice = Object.create(devicePrototype)
    				Object.assign(newGameDevice, modules.device)
    				devicePrototype.constructor.call(newGameDevice, msg, modules.navigation, device, helpers, device.schemeId)
    				modules = copyObj({}, modules)
    				modules.device = newGameDevice
    			}
    			
    			if (!msg) {
    				throw new Error("Sub Package Error: Can't find Tactic ID:" + tactic.id + " as " + (subPackage.data || {}).title)
    			}
    			
    			return lookupAndLoad(msg)
    				.then(function (packageName){
    					return window[packageName].default(
    						modules,
    						config || resolveThreeRadicalConfig(msg, options),
    						el,
    						msg
    					)
    				})
    				
    			function copyObj(to, from) {
    				for (let k in from) {
    					if (from.hasOwnProperty(k)) {
    						to[k] = from[k]
    					}
    				}
    				
    				return to
    			}
    		}
    		
    		fn.systemId = subPackage.tactic.id
    		
    		return fn
    	}
    	
		return function(modules, config, el, msg) {
			return loadSubPackage(subPackage).then(function(subPackageName) {
				return window[subPackageName].default(
					modules,
					config || helpers.resolveThreeRadical(subPackage.value, 'value', true),
					el,
					msg || (modules.parent || {}).message
				)
			})
	  	}
    	
    	function loadSubPackage(subPackage) {
    		return getSubPackageName(subPackage)
    		.then(function(subPackageName) {
    			subPackageName = helpers.camelCase(subPackageName)
    			
    			if(window[subPackageName]) {
    				return subPackageName
    			} else {
    				return loadScript(device.schemeId, subPackage.url)
    				.then(function () {
    					return subPackageName
    				})
    			}
    		})
    	}
    	
    	function getSubPackageName(subPackage) {
    		let guid = getPackageGuid(subPackage.url)
    		
    		if (guidNames && guidNames[guid]) {
    			return Promise.resolve(guidNames[guid])
    		}
    		
    		return device.gtp("/external-package/" + device.schemeId + "/" + getPackageGuid(subPackage.url) + "/package/name")
    		.then(function (name){
    		    if(guidNames) {
    			    guidNames[guid] = name
    		    }
    			return name
    		})
    	}
    }
    
    resolveThreeRadicalSubPackage._depends = {
        symbol : "3r/chi/resolveThreeRadicalSubPackage",
        modules : [
            "3r/Device",
            "3r/chi/helpers",
            "3r/chi/loadScript",
            "3r/chi/getPackageGuid",
            "3r/chi/isMessageVisible",
            "3r/chi/lookupAndLoad",
            "3r/chi/resolveThreeRadicalConfig"
        ]
    }
    
    function getPackageUrl(schemeSettings, getPackageNameLocal, message) {
        if (typeof message == "string") {
            return message;
        }
        
    	var externalPackage = (((message.quantities || {}).link || {}).data || {}).externalPackage
    
        var packageName = getPackageNameLocal(message);
    
        if (schemeSettings && packageName) {
            var schemePackages = (schemeSettings.globals || {}).schemePackages || []
            var schemePackage = schemePackages.filter(function (pkg) {
                return (pkg['_package'] || {}).name == packageName
            })[0]
    
            if (schemePackage && schemePackage.file) {
                return schemePackage.file 
            }
        }
    	
    	if (externalPackage.uploadOption && externalPackage.uploadOption == "selectPackage") {
    		return externalPackage.selectedPackageFile
    	}
    	
    	return externalPackage.metadataPath
    }
    
    getPackageUrl._depends = {
        symbol : "3r/chi/getPackageUrl",
        modules : [
            {
                symbol : "3r/schemeSettings/webapp",
                nullIfMissing : true
            },
            "3r/chi/getPackageNameLocal"
        ]
    }
    
    
    function getPackageGuid(args) {
        var argParts = args.split('/')
        return argParts[argParts.length - 1].replace('.zip', '')
    }
    
    getPackageGuid._depends = {
        symbol : "3r/chi/getPackageGuid"
    }
    
    function getPackageNameLocal(schemeSettings, getThreeRadical, message) {
        var threeRadical = getThreeRadical(message)
        
        if (threeRadical && threeRadical._package && threeRadical._package.name) {
            return threeRadical._package.name
        }
    }
    
    getPackageNameLocal._depends = {
        symbol : "3r/chi/getPackageNameLocal",
        modules : [
            {
                symbol : "3r/schemeSettings/webapp",
                nullIfMissing : true
            },
            "3r/chi/getThreeRadical"
        ]
    }
    
    function getThreeRadical(message) {
    	return ((((message.quantities || {}).link || {}).data || {}).externalPackage || {}).threeRadical
    }
    
    getThreeRadical._depends = {
        symbol : "3r/chi/getThreeRadical",
        modules : []
    }
    
    function getPackageName(Promise, getPackageNameLocal, Device, getPackageUrl, getPackageGuid, message) {
        var localPackageName = getPackageNameLocal(message)
        if (localPackageName) {
            return Promise.resolve(localPackageName)
        }
        
        var packageGuid = getPackageGuid(getPackageUrl(message))
        
        return Device.gtp("/external-package/" + message.schemeId + "/" + packageGuid + "/package/name")
    }
    
    getPackageName._depends = {
        symbol : "3r/chi/getPackageName",
        modules : [
            "Promise",
            "3r/chi/getPackageNameLocal",
            "3r/Device",
            "3r/chi/getPackageUrl",
            "3r/chi/getPackageGuid"
        ]
    }
    
    function getSchemePackageName(Device, getPackageGuid, schemePackage) {
        var packageName = null
        if (schemePackage["_package"]) {
            packageName = schemePackage["_package"].name
        }
        
        if (packageName) {
            return Promise.resolve(packageName)
        }
        
        var packageGuid = getPackageGuid(schemePackage.file)
        
        return Device.gtp("/external-package/" + Device.schemeId + "/" + packageGuid + "/package/name")
            .then(function(pkgName) {
                if (!schemePackage['_package']) {
                    schemePackage['_package'] = {}
                }
                schemePackage['_package'].name = pkgName
                return pkgName
            })
    }
    
    getSchemePackageName._depends = {
        symbol : "3r/chi/getSchemePackageName",
        modules : [
            "3r/Device",
            "3r/chi/getPackageGuid"
        ]
    }
    
    if (isNode) {
        module.exports = {
            getPackageName : getPackageName,
            getThreeRadical : getThreeRadical,
            getPackageNameLocal : getPackageNameLocal,
            getPackageUrl : getPackageUrl,
            getPackageGuid : getPackageGuid,
            createMainScript : createMainScript,
            loadPackage : loadPackage,
            lookupAndLoad : lookupAndLoad,
            isMessageVisible : isMessageVisible,
            getSchemePackageName : getSchemePackageName,
            loadScript : loadScript,
            resolveThreeRadicalConfig: resolveThreeRadicalConfig,
			resolveThreeRadicalSubPackage: resolveThreeRadicalSubPackage
        }
    } else {
        root.chiIoc = {
            getPackageName : getPackageName,
            getThreeRadical : getThreeRadical,
            getPackageNameLocal : getPackageNameLocal,
            getPackageUrl : getPackageUrl,
            getPackageGuid : getPackageGuid,
            createMainScript : createMainScript,
            loadPackage : loadPackage,
            lookupAndLoad : lookupAndLoad,
            isMessageVisible : isMessageVisible,
            getSchemePackageName : getSchemePackageName,
            loadScript : loadScript,
            resolveThreeRadicalConfig: resolveThreeRadicalConfig,
			resolveThreeRadicalSubPackage: resolveThreeRadicalSubPackage
        }
    }
    
    return {
        getPackageName : getPackageName,
        getThreeRadical : getThreeRadical,
        getPackageNameLocal : getPackageNameLocal,
        getPackageUrl : getPackageUrl,
        getPackageGuid : getPackageGuid,
        createMainScript : createMainScript,
        loadPackage : loadPackage,
        lookupAndLoad : lookupAndLoad,
        isMessageVisible : isMessageVisible,
        getSchemePackageName : getSchemePackageName,
        loadScript : loadScript,
        resolveThreeRadicalConfig: resolveThreeRadicalConfig,
		resolveThreeRadicalSubPackage: resolveThreeRadicalSubPackage
    }

})();
